module.exports = __webpack_public_path__ + "fonts/summernote.132b3ed5.eot";